var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"findPass"}},[_c('h1',[_vm._v("找回密码")]),_c('el-button',{on:{"click":_vm.goLogin}},[_vm._v("返回登录页面")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }